const matEconomicBusiness = [
  {
    id: 121,
    question: "The Reserve Bank of India was established in the year:",
    options: ["A. 1935", "B. 1947", "C. 1949", "D. 1955"],
    answer: "A"
  },
  {
    id: 122,
    question: "GST in India follows which structure?",
    options: [
      "A. Single unified tax",
      "B. Dual structure — CGST and SGST",
      "C. Only IGST",
      "D. State-only taxation"
    ],
    answer: "B"
  },
  {
    id: 123,
    question: "'Scalar chain' in management theory was propounded by:",
    options: ["A. F.W. Taylor", "B. Henri Fayol", "C. Elton Mayo", "D. Peter Drucker"],
    answer: "B"
  },
  {
    id: 124,
    question: "The concept of 'Management by Objectives' (MBO) was introduced by:",
    options: ["A. Henri Fayol", "B. Peter F. Drucker", "C. Elton Mayo", "D. F.W. Taylor"],
    answer: "B"
  },
  {
    id: 125,
    question: "Which of the following best describes 'Liquidity Trap' in economics?",
    options: [
      "A. High interest rates reducing investment",
      "B. Monetary policy becoming ineffective as interest rates near zero",
      "C. Excess liquidity causing asset bubbles",
      "D. Consumer spending declining due to inflation"
    ],
    answer: "B"
  },
  {
    id: 126,
    question: "The headquarters of the International Monetary Fund (IMF) is located in:",
    options: ["A. Geneva", "B. Washington D.C.", "C. New York", "D. Brussels"],
    answer: "B"
  },
  {
    id: 127,
    question: "'Angel investors' are best described as those who:",
    options: [
      "A. Only invest in publicly listed companies",
      "B. Provide funding at an early stage of a startup",
      "C. Regulate stock market transactions",
      "D. Provide loans to government projects"
    ],
    answer: "B"
  },
  {
    id: 128,
    question: "Which of the following best defines an 'IPO' in business finance?",
    options: [
      "A. A loan given by a bank to a startup",
      "B. The process by which a private company offers shares to the public for the first time",
      "C. A merger between two companies",
      "D. A government subsidy scheme for exporters"
    ],
    answer: "B"
  },
  {
    id: 129,
    question: "Which of the following is NOT one of the four Ps of the marketing mix?",
    options: ["A. Product", "B. Price", "C. Place", "D. Profit"],
    answer: "D"
  },
  {
    id: 130,
    question: "SEBI stands for:",
    options: [
      "A. Securities and Exchange Board of India",
      "B. State Economic Bureau of India",
      "C. Society for Economic and Banking Innovation",
      "D. Stock Exchange Board of India"
    ],
    answer: "A"
  },
  {
    id: 131,
    question: "Which body replaced the Planning Commission of India?",
    options: ["A. Finance Commission", "B. NITI Aayog", "C. RBI", "D. SEBI"],
    answer: "B"
  },
  {
    id: 132,
    question: "The term 'repo rate' refers to:",
    options: [
      "A. The rate at which RBI lends money to commercial banks",
      "B. The rate at which commercial banks lend to customers",
      "C. The interest rate on government bonds",
      "D. The rate at which foreign currency is exchanged"
    ],
    answer: "A"
  },
  {
    id: 133,
    question: "'Reverse repo rate' refers to:",
    options: [
      "A. The rate at which RBI borrows money from commercial banks",
      "B. The rate at which banks lend to each other",
      "C. The rate charged on home loans",
      "D. The rate of return on mutual funds"
    ],
    answer: "A"
  },
  {
    id: 134,
    question: "Which of the following best defines 'inflation'?",
    options: [
      "A. A sustained increase in the general price level of goods and services",
      "B. A decrease in the money supply",
      "C. An increase in unemployment",
      "D. A decrease in GDP"
    ],
    answer: "A"
  },
  {
    id: 135,
    question: "'Stagflation' refers to a situation of:",
    options: [
      "A. High growth and low inflation",
      "B. High inflation combined with stagnant economic growth and high unemployment",
      "C. Falling prices and rising employment",
      "D. Balanced growth and stable prices"
    ],
    answer: "B"
  },
  {
    id: 136,
    question: "The Union Budget of India is traditionally presented first in which house of Parliament?",
    options: ["A. Rajya Sabha", "B. Lok Sabha", "C. Both simultaneously", "D. State Legislature"],
    answer: "B"
  },
  {
    id: 137,
    question: "GDP stands for:",
    options: [
      "A. Gross Domestic Product",
      "B. General Development Plan",
      "C. Gross Development Price",
      "D. Government Debt Position"
    ],
    answer: "A"
  },
  {
    id: 138,
    question: "Which organization publishes the Human Development Index (HDI)?",
    options: ["A. World Bank", "B. United Nations Development Programme (UNDP)", "C. IMF", "D. WTO"],
    answer: "B"
  },
  {
    id: 139,
    question: "'Disinvestment' by the government refers to:",
    options: [
      "A. Increasing investment in public sector units",
      "B. Selling of government stake in public sector enterprises",
      "C. Borrowing from international agencies",
      "D. Printing new currency"
    ],
    answer: "B"
  },
  {
    id: 140,
    question: "Which of the following is a direct tax?",
    options: ["A. GST", "B. Income Tax", "C. Excise Duty", "D. Customs Duty"],
    answer: "B"
  },
  {
    id: 141,
    question: "The Bombay Stock Exchange (BSE) benchmark index is known as:",
    options: ["A. Nifty", "B. Sensex", "C. Dow Jones", "D. FTSE"],
    answer: "B"
  },
  {
    id: 142,
    question: "The National Stock Exchange (NSE) benchmark index is known as:",
    options: ["A. Sensex", "B. Nifty", "C. Dow Jones", "D. Hang Seng"],
    answer: "B"
  },
  {
    id: 143,
    question: "In Maslow's Hierarchy of Needs, which need sits at the highest level?",
    options: ["A. Physiological needs", "B. Safety needs", "C. Self-actualization", "D. Social needs"],
    answer: "C"
  },
  {
    id: 144,
    question:
      "'Scientific Management' theory, which focused on improving efficiency through time and motion studies, was propounded by:",
    options: ["A. Henri Fayol", "B. F.W. Taylor", "C. Peter Drucker", "D. Elton Mayo"],
    answer: "B"
  },
  {
    id: 145,
    question:
      "The 'Hawthorne Studies', which highlighted the importance of social factors in the workplace, were conducted under the guidance of:",
    options: ["A. F.W. Taylor", "B. Elton Mayo", "C. Henri Fayol", "D. Abraham Maslow"],
    answer: "B"
  },
  {
    id: 146,
    question: "'Balance of Payments' records:",
    options: [
      "A. Only a country's export transactions",
      "B. All economic transactions between a country and the rest of the world",
      "C. Only government borrowing",
      "D. A company's annual profit and loss"
    ],
    answer: "B"
  },
  {
    id: 147,
    question: "Which of the following best describes 'working capital'?",
    options: [
      "A. The total assets of a company",
      "B. The difference between current assets and current liabilities",
      "C. The long-term debt of a company",
      "D. The market value of a company's shares"
    ],
    answer: "B"
  },
  {
    id: 148,
    question: "The 'break-even point' in business refers to the point at which:",
    options: [
      "A. Total revenue equals total cost",
      "B. Profit is maximum",
      "C. Fixed costs become zero",
      "D. Sales are at their peak"
    ],
    answer: "A"
  },
  {
    id: 149,
    question:
      "Which of the following describes a merger where two companies from unrelated industries combine?",
    options: ["A. Horizontal merger", "B. Vertical merger", "C. Conglomerate merger", "D. Market-extension merger"],
    answer: "C"
  },
  {
    id: 150,
    question: "The World Trade Organization (WTO) headquarters is located in:",
    options: ["A. Geneva", "B. New York", "C. Washington D.C.", "D. Paris"],
    answer: "A"
  }
];

export default matEconomicBusiness;